interface BatchActionsBarProps {
	selectedCount: number;
	totalCount: number;
	onSelectAll: () => void;
	onClearSelection: () => void;
	onBatchDelete: () => void;
}

export default function BatchActionsBar(props: BatchActionsBarProps) {
	const { selectedCount, totalCount, onSelectAll, onClearSelection, onBatchDelete } = props;

	return (
		<div className="batch-actions-bar">
			<div className="batch-actions-selection-info">
				{selectedCount} of {totalCount} selected
			</div>
			<div className="batch-actions-actions">
				{selectedCount < totalCount && (
					<button className="btn btn-default btn-sm" onClick={onSelectAll}>
						Select All
					</button>
				)}
				<button className="btn btn-default btn-sm" onClick={onClearSelection}>
					Clear Selection
				</button>
				<button className="btn btn-danger btn-sm" onClick={onBatchDelete}>
					<i className="fas fa-trash" style={{ marginRight: '0.5rem' }}></i>
					Delete ({selectedCount})
				</button>
			</div>
		</div>
	);
}
